<app-auth-layout>
    <div class="register-wrapper">
        <img class="logo" src="./assets/images/logo.svg" />
        <app-error *ngIf="errCode" [errcode]="errCode" />
        
        <div class="register-form">
            <div class="header">
                <h3>Get Sync</h3>
                <h5>Sign up below or <a [href]="upgradelink">log in.</a></h5>
            </div>
            <form [formGroup]="form" (ngSubmit)="submit()">
                <div class="fields">
                    <sync-text-field class="text-field" label="Email" inputType="text" formControlName="email"
                        [errorMessage]="getErrorMessage('email')" />
                    <sync-text-field class="text-field" label="Password" inputType="password" [inputChange]="onInputChange"
                        formControlName="password" [errorMessage]="getErrorMessage('password')" />
                    <app-complex-password [password]="form?.controls?.password?.value">
                    </app-complex-password>
                    <sync-text-field class="text-field" label="Confirm password" inputType="password"
                        [inputChange]="onInputChange" formControlName="confirmPassword"
                        [errorMessage]="getErrorMessage('confirmPassword')" />
        
                    <sync-select *ngIf="showTerm" label="Term" [list]="termList" formControlName="term">
                    </sync-select>
        
                    <div class="terms-checkbox">
                        <sync-checkbox id="terms"
                        ariaLabel="I accept the Sync Terms of Service and Privacy Policy"
                        [checked]="form?.controls?.terms?.value"
                        [indeterminate]="false"
                        formControlName="terms">
                        </sync-checkbox>
                        <label for="terms">
                            I accept the Sync
                            <a target="_blank" rel="noopener" href="https://www.sync.com/terms/">Terms of
                                Service</a> and <a target="_blank" rel="noopener" href="https://www.sync.com/privacy/">Privacy Policy</a>
                        </label>
                    </div>
                </div>
        
                <div class="buttons">
                    <sync-button [disabled]="form?.invalid" nativeType="submit" type="filled" label="Continue"
                        [isLoading]="spinner" buttonWidth="236">
                    </sync-button>
                </div>
                <sync-divider></sync-divider>
            </form>
        </div>
    </div>
</app-auth-layout>